/** The existing prompt as a dictation continues it: one space before the new text, unless it already ends in whitespace. */
export const getDictationPrefix = (existing: string) =>
	existing === '' || /\s$/.test(existing) ? existing : `${existing} `;

export const joinDictation = (existing: string, transcript: string) =>
	transcript ? `${getDictationPrefix(existing)}${transcript}` : existing;
